
import React from 'react';

export default class Header extends React.Component {
    render() {
        return (
            <h2 className="ds-page-title" style={this.props.style}>{this.props.title}</h2>
        );
    }
}
